import React from "react";
import Header from "../../common/components/Header";
import {Grid} from "semantic-ui-react";
import { connect } from "react-redux";
import Breadcrumb from "../../common/partials/Breadcrumb";
import { setBreadCrumb } from "../../veritas/breadcrumb/BreadcrumbActions";
import Sidebar from "../../common/components/Sidebar";
import BillingSidebarButtons from "./BillingSidebarButtons";

export class BillingHomePage extends React.Component {

    componentDidMount() {
        document.title = `Marvel - Billing`;

        this.props.setBreadCrumb({
            parent: { url: '/billing', text: 'Billing   ' },
            list: { url: '', text: '' },
            service: { url: '', text: '' },
            source: { url: '', text: '' }
        })
    }

    pageContent(){
        return (
            <div className="billing-container">
                <p>WELCOME TO BILLING</p>
            </div>
        );
    }

    render() {
        return(
            <div className="billing">
                <Header/>
                <Grid relaxed={true}>
                    <Grid.Column width={3}>
                        <Sidebar>
                            <BillingSidebarButtons />
                        </Sidebar>
                    </Grid.Column>
                    <Grid.Column width={13}>
                        <Breadcrumb />
                        {this.pageContent()}
                    </Grid.Column>
                </Grid>
            </div>
        );
    }
}
const mapStateToProps = (state) => ({

});

const mapDispatchToProps = dispatch => ({
    setBreadCrumb: (crumb) => { dispatch(setBreadCrumb(crumb)) },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(BillingHomePage)
